import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MoreVertRounded from '@mui/icons-material/MoreVertRounded';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import OutsideAlerter from 'shared/components/outside-alerter/outside-alerter';
import PopUp from 'shared/components/pop-up/pop-up';
import Routes from 'shared/enums/routes';
import AuthProviderContext from 'shared/features/auth/authentication/providers/contexts/auth-provider-context';

import UserDetails from 'features/menu/components/user-menu/user-details.component';
import { useUserMenu } from './hooks';
import styles from './user-menu.module.scss';

const UserMenu = (): React.JSX.Element => {
  const { t } = useTranslation('menu');
  const { backChannelLogoutIsLoading } = use(AuthProviderContext);

  const {
    isMenuOpen,
    isLogoutPopupOpen,
    tenantName,
    fullName,
    initials,
    goToRoute,
    toggleMenu,
    closeMenu,
    openLogoutPopUp,
    closeLogoutPopUp,
    confirmLogout,
  } = useUserMenu();

  return (
    <>
      <OutsideAlerter funcDelegate={closeMenu}>
        <div className={`${styles.menuContainer} ${isMenuOpen ? styles.isOpen : ''}`}>
          <div className={styles.header}>
            <Typography variant="h5" className={styles.tenant}>
              {tenantName}
            </Typography>
            <IconButton onClick={toggleMenu}>
              <MoreVertRounded />
            </IconButton>
          </div>
          <UserDetails fullName={fullName} initials={initials} />
          <div className={styles.container}>
            <ul>
              <ListItem disablePadding>
                <ListItemButton
                  data-testid="menu-item-appInformation"
                  className={styles.listItemButtonStyle}
                  onClick={() => goToRoute(Routes.AppInformation)}
                >
                  <Typography variant="h5">{t('appInformation')}</Typography>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton data-testid="menu-item-logout" onClick={openLogoutPopUp} className={styles.listItemButtonStyle}>
                  <ListItemIcon className={styles.listItemIconStyle}>
                    <LogoutRoundedIcon />
                  </ListItemIcon>
                  <Typography variant="h5">{t('logout')}</Typography>
                </ListItemButton>
              </ListItem>
            </ul>
            <UserDetails fullName={fullName} initials={initials} />
          </div>
        </div>
      </OutsideAlerter>

      <PopUp
        isOpen={isLogoutPopupOpen}
        title={t('logoutPopup.title')}
        body={t('logoutPopup.body')}
        primaryButtonText={t('logoutPopup.primaryButtonText')}
        secondaryButtonText={t('logoutPopup.secondaryButtonText')}
        handleOnClose={closeLogoutPopUp}
        secondaryButtonAction={() => closeLogoutPopUp()}
        primaryButtonAction={confirmLogout}
        isLoadingPrimaryAction={backChannelLogoutIsLoading}
      />
    </>
  );
};

export default UserMenu;
